import './LoadingSpinner.css'

const baseClass = 'loading-spinner'

const LoadingSpinner = () => {
  return <div className={`${baseClass}__root`} />
}

export default LoadingSpinner
